<template>
  <div class="native-col" :style="{ gridColumn: `span ${span} / span ${span}` }">
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{ span?: number }>(), { span: 12 });
</script>

<style scoped>
.native-col { min-width: 0; }

@media (max-width: 640px) {
  .native-col { grid-column: 1 / -1 !important; }
}
</style>
